import React from 'react'
import SlugTable from '../utils/SlugTable'
import { useParams } from 'react-router-dom'

const AdminSlug = () => {
  const { operation, arg } = useParams()
  return <SlugTable mode={operation === 'byEmailDomain' ? 'byEmailDomain' : 'byEmail'} arg={arg} />
}

export default AdminSlug